import React from 'react';
import { motion } from 'framer-motion';
export const CHECKOUT_URL = 'https://mega-pack-chi-kung.impultienda.ar/checkout';
export const Section = ({
  children,
  className = '',
  id = '',
  glow = false
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
  glow?: boolean;
}) => <motion.section id={id} initial={{
  opacity: 0,
  y: 30
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-100px'
}} transition={{
  duration: 0.6
}} className={`relative py-12 md:py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full bg-transparent ${className} pt-[4px]`} data-id="element-268" data-mp="185oxxycieqgz">
    {glow && <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10 overflow-hidden" data-id="element-269" data-mp="pf7aa86jal2h">
        <div className="absolute inset-3 border border-brand-goldDark/15" data-id="element-270" data-mp="1vtos78914z0b" />
      </div>}
    {children}
  </motion.section>;
export const CTAButton = ({
  children,
  href,
  className = '',
  fullWidth = false,
  variant = 'purple'
}: {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'purple' | 'gold';
}) => {
  const bgClass = variant === 'purple' ? 'bg-brand-burgundy hover:bg-brand-burgundyDark' : 'bg-brand-gold hover:bg-brand-goldDark';
  const classes = `inline-flex items-center justify-center px-8 py-4 font-display text-sm font-semibold uppercase tracking-[0.18em] text-brand-surface ${bgClass} rounded-sm transition-colors duration-200 ease-out cursor-pointer ${fullWidth ? 'w-full' : ''} ${className}`;
  if (href) {
    return <motion.a href={href} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={classes} data-id="element-271" data-mp="2gvvbnfow3l6u">
        {children}
      </motion.a>;
  }
  return <motion.a href={CHECKOUT_URL} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={classes} data-id="element-272" data-mp="22vkl6drhs8m7">
      {children}
    </motion.a>;
};